import {
  TextField,
  TextInput,
  TopToolbar,
  useRecordContext,
} from "react-admin";
import { RecordSummary, MyShow } from "../../ra-lb-tools/components/MyShow";
import { useParams } from "react-router-dom";
import { JsonField } from "../../ra-lb-tools/components/jsonField";
import { TowerList } from "../tower/towers";
import { FederationList } from "../federatios";
import { LabeledColumn } from "../../ra-lb-tools/components/labeledColumn";
import { GoBackButton } from "../../ra-lb-tools/components/goBackButton";
import { MyEdit } from "../../ra-lb-tools/components/myMutator";
import { Edit } from "@mui/icons-material";
import { TagNameField } from "../firmware";
import { LocationImageList } from "../locationImage";
import { MyEditButton as EditButton } from "../../ra-lb-tools/components/myEditButton";
import {
  MyTabbedShowLayout,
  Tab,
} from "../../ra-lb-tools/components/myTabbedShowLayout";
import { LockerUsageList } from "../billing/lockerUsage";
import { UserField } from "../users";
import { LinkButton } from "../../ra-lb-tools/components/linkButton";
import { LockerList } from "../lockers";
import { WithPermissions } from "../../ra-lb-tools/acl/withPermissions";

export const LocationFirmwareEdit = (props) => {
  return (
    <MyEdit
      {...props}
      formProps={{
        shouldUnregister: true,
      }}
      mutationOptions={{
        meta: { customSegment: "firmware", customMethod: "POST" },
      }}
      permissionAction="set_recommended_firmware"
    >
      <TextInput source="id" disabled />
      <TextInput source="name" disabled />
      <TextInput source="tagName" />
    </MyEdit>
  );
};

const EditFirmwareButton = () => {
  const record = useRecordContext();

  if (!record) return null;
  const path = `/locations/${record.id}/firmware`;

  return (
    <WithPermissions
      can={{ resource: "locations", action: "set_recommended_firmware" }}
    >
      <LinkButton
        to={path}
        label={"Firmware"}
        onClick={(e) => e.stopPropagation()}
      >
        <Edit />
      </LinkButton>
    </WithPermissions>
  );
};

const LocationShowActions = () => (
  <TopToolbar>
    <EditButton />
    <EditFirmwareButton />
    <GoBackButton size="small" variant="text" />
  </TopToolbar>
);

export const LocationShow = () => {
  const id = parseInt(useParams()["id"]);

  return (
    <MyShow actions={<LocationShowActions />}>
      <MyTabbedShowLayout>
        <Tab label="Summary" can={true}>
          <RecordSummary>
            <LabeledColumn>
              <TextField source="id" />
              <TextField source="name" />
              <TextField source="address1" />
              <TextField source="address2" />
              <TextField source="description" />
              <TextField source="directions" />
              <TagNameField source="firmware.tagName" />
              <TextField source="firmware.version" />
            </LabeledColumn>
            <LabeledColumn>
              <TextField source="lat" />
              <TextField source="lon" />
              <TextField source="city" />
              <TextField source="state" />
              <TextField source="zip" />
              <TextField source="country" />
              <TextField source="timezone" />
              <TextField source="doorAccessCode" />
            </LabeledColumn>
            <LabeledColumn>
              <UserField source="ownerId" />
              <TextField source="towerCount" />
              <TextField source="notes" />
              <JsonField source="accessHours" maxLines={null} />
            </LabeledColumn>
          </RecordSummary>
        </Tab>
        <Tab
          label="Towers"
          path="towers"
          can={{ action: "list", resource: "towers" }}
        >
          <TowerList filter={{ locationId: id }} />
        </Tab>
        <Tab
          label="Retired Towers"
          path="towers-retired"
          can={{ action: "list", resource: "towers" }}
        >
          <TowerList filter={{ locationId: id, statusId: 4 }} />
        </Tab>
        <Tab
          label="Lockers"
          path="lockers"
          can={{ action: "list", resource: "lockers" }}
        >
          <LockerList filter={{ tower__location_id: id }} />
        </Tab>
        <Tab
          label="Federations"
          path="federations"
          can={{ action: "list", resource: "federations" }}
        >
          <FederationList filter={{ locationId: id }} />
        </Tab>
        <Tab
          label="Images"
          path="images"
          can={{ action: "list", resource: "location-image" }}
        >
          <LocationImageList filter={{ locationId: id }} />
        </Tab>
        <Tab
          label="Locker Usage"
          path="locker-usage"
          can={{
            action: "list",
            resource: "locker-usage",
          }}
          key="locker-usage"
        >
          <LockerUsageList filter={{ locationId: id }} />
        </Tab>
      </MyTabbedShowLayout>
    </MyShow>
  );
};
